import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppLoaderInterceptor, CoreModule, ErrorsModule } from "common";
import { CalculatorModule } from "./calculator/calculator.module";
import { BankLinkingModule } from "./bank-linking/bank-linking.module";

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    CalculatorModule,
    BankLinkingModule,
    SharedModule,
    CoreModule,
    ErrorsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AppLoaderInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
